import { Modal } from "react-bootstrap";
import "../styles/css/admin-style.css"

interface ConfirmationModalProps {
    show: boolean;
    toggle: () => void;
    onConfirm: () => void;
    confirmButtonText?: string
    cardText?: string
    isDanger?: boolean
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ show, toggle, onConfirm, cardText = 'Are you sure you want to delete this?', confirmButtonText = 'Yes, Delete', isDanger = true}) => {

    return (
    <Modal className={'forRealModal'} show={show} onHide={toggle}>
        <Modal.Body className={'text-center'}>
            <span className={isDanger ? 'text-danger icon mb-3' : 'text-link-blue icon mb-3'}>
                <i className="fa-solid fa-square-exclamation"></i>
            </span>
            <p className="mb-4">
                {cardText}
            </p>
            <div className="mb-2">
                <button className={isDanger ? "btn btn-outline-danger text-strong text-uppercase m-100" : "btn btn-outline-link-blue text-strong text-uppercase m-100"} onClick={() => {onConfirm(); toggle();}}>
                    {confirmButtonText}
                </button>
            </div>
            <div className="pb-2">
                <a style={{cursor: 'pointer'}} className="m-100 text-muted" onClick={toggle}>
                    Nevermind
                </a>
            </div>
        </Modal.Body>
        </Modal>
    );
};
export default ConfirmationModal;


